import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const CATEGORIES = [{
  id: "01",
  title: "Peer-Reviewed Papers",
  desc: "Original research articles undergoing rigorous double-blind peer review before publication."
}, {
  id: "02",
  title: "Books & Edited Volumes",
  desc: "Comprehensive historical anthologies and monographs published in collaboration with global universities."
}, {
  id: "03",
  title: "PhD & MPhil Theses",
  desc: "A centralized repository of postgraduate academic research concerning the diaspora."
}, {
  id: "04",
  title: "Working Papers",
  desc: "Pre-publication scholarly drafts and policy briefs exploring contemporary socio-economic issues."
}, {
  id: "05",
  title: "Conference Proceedings",
  desc: "Documented transcripts, panels, and presentations from the Council's global symposiums."
}, {
  id: "06",
  title: "Edited Collections",
  desc: "Curated compilations of primary archival sources, manifests, and translated oral histories."
}];
const FONT_STYLE = `
    .cat-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.03'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 10;
    }
`;
const PublicationCategories = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{FONT_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A]">The Archive Taxonomy</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-10 sm:mb-14 md:mb-20">{t1}<h2 className="font-display text-[32px] sm:text-[40px] md:text-[44px] lg:text-[56px] text-[#F4EFE6] leading-none mb-4 sm:mb-6">Publication <em className="text-[#C9A84C] italic">Categories</em></h2></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t0}<section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32 relative overflow-hidden cat-grain"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 relative z-20">{t2}<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">{CATEGORIES.map(_temp)}</div></div></section></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default PublicationCategories;
function _temp(cat, idx) {
  return <motion.div key={cat.id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: idx * 0.1
  }} className="group border border-white/10 p-6 sm:p-8 md:p-10 hover:bg-[#F4EFE6]/5 transition-colors duration-300 cursor-pointer flex flex-col"><span className="font-display text-[36px] sm:text-[42px] md:text-[48px] text-[#DF6D2A] leading-none mb-4 sm:mb-6 opacity-50 group-hover:opacity-100 group-hover:-translate-y-2 transition-all duration-300">{cat.id}</span><h3 className="font-display text-[20px] sm:text-[24px] md:text-[26px] text-[#F4EFE6] mb-3 sm:mb-4 group-hover:text-[#C9A84C] transition-colors">{cat.title}</h3><p className="font-body text-[13px] sm:text-[14px] text-white/50 leading-[1.6] sm:leading-[1.7] flex-grow">{cat.desc}</p><div className="mt-5 sm:mt-6 md:mt-8 pt-4 sm:pt-5 md:pt-6 border-t border-white/10 flex justify-between items-center text-[#DF6D2A] opacity-0 group-hover:opacity-100 transition-opacity duration-300"><span className="font-body text-[10px] tracking-[0.2em] uppercase">Browse Index</span><span>→</span></div></motion.div>;
}